type Environment = "local" | "dev" | "prod";

function detectEnvironment(): Environment {
  if (import.meta.env.VITE_ENVIRONMENT) {
    return import.meta.env.VITE_ENVIRONMENT as Environment;
  }

  if (import.meta.env.DEV) {
    return "local";
  }

  const hostname = typeof window !== "undefined" ? window.location.hostname : "";
  if (hostname.startsWith("dev-") || hostname.includes(".dev.")) {
    return "dev";
  }

  return "prod";
}

export const environment: Environment = detectEnvironment();

export const isLocal = environment === "local";
export const isDev = environment === "dev";
export const isProd = environment === "prod";

export const enableDevTools = isLocal;

export const appVersion: string = import.meta.env.VITE_APP_VERSION;

export const versionLabel: string = isProd
  ? appVersion
  : `${appVersion} (${environment})`;
